<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>

<div class="container" style="min-height: 62vh">
    <div class="bg-white">
        <div class="reports-heading mb-3 mt-2 px-3 flex-wrap gap-2">
            <div class="ms-1 top-bar-div">
                <div class="mt-3">
                    <h6>Payment History</h6>
                </div>
            </div>

            <div class="right-buttons mt-3">
                <div
                        ngbDropdown
                        class="dropdown"
                        *ngIf="countDetails || details?.length > 0"
                >
<!--                    <button-->
<!--                            *ngIf="!isSearching && !isEmpty"-->
<!--                            class="btn download-button"-->
<!--                            id="downloadDropdown"-->
<!--                            ngbDropdownToggle-->
<!--                    >-->
<!--                        <span class="mdi mdi-download"></span> Download Report-->
<!--                    </button>-->
<!--                    <div ngbDropdownMenu aria-labelledby="downloadDropdown">-->
<!--                        <button-->
<!--                                class="dropdown-item small-option-font"-->
<!--                                (click)="downloadCSV()"-->
<!--                        >-->
<!--                            CSV-->
<!--                        </button>-->
<!--                        <button-->
<!--                                class="dropdown-item small-option-font"-->
<!--                                (click)="downloadExcel()"-->
<!--                        >-->
<!--                            Excel-->
<!--                        </button>-->
<!--                        <button-->
<!--                                class="dropdown-item small-option-font"-->
<!--                                (click)="downloadPDF()"-->
<!--                        >-->
<!--                            PDF-->
<!--                        </button>-->
<!--                    </div>-->
                </div>

                <div class="text-end mt-4">
                    <button
                            (click)="toggleFilter()"
                            class="btn btn-outline-secondary rounded-pill fs-16 py-1 px-3"
                    >
                        <ng-container *ngIf="!showFilters"
                        ><span
                        ><span
                                class="iconify icon"
                                data-icon="basil:filter-outline"
                        ></span>
                Filter</span
                        ></ng-container
                        >
                        <ng-container *ngIf="showFilters"
                        ><span
                        ><span
                                class="iconify icon"
                                data-icon="mdi:filter-off-outline"
                        ></span>
                Hide Filters</span
                        ></ng-container
                        >
                    </button>
                </div>
            </div>
        </div>

        <div class="search-parameters" *ngIf="showFilters">
            <form class="search-form" [formGroup]="searchForm">
                <div class="row mt-2 mb-3">
                    <div class="col-md-6 col-lg-4">
                        <label class="form-label">From</label>
                        <div class="input-group">
                            <input
                                #dp="bsDatepicker"
                                bsDatepicker
                                type="text"
                                class="form-control small-option-font"
                                placeholder="mm/dd/yyyy"
                                formControlName="from"
                                [maxDate]="now()"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-orange' }"
                            />
                            <span class="input-group-text bg-white" (click)="dp.toggle()"
                            ><span class="iconify" data-icon="uil:calender"></span
                            ></span>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <label class="form-label">To</label>
                        <div class="input-group">
                            <input
                                #dp1="bsDatepicker"
                                bsDatepicker
                                type="text"
                                class="form-control small-option-font"
                                placeholder="mm/dd/yyyy"
                                formControlName="to"
                                [minDate]="minDateValue"
                                [maxDate]="now()"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-orange' }"
                            />
                            <span class="input-group-text bg-white" (click)="dp1.toggle()"
                            ><span class="iconify" data-icon="uil:calender"></span
                            ></span>
                        </div>
                    </div>


                    <div class="col-md-4 mt-2">
                        <label>ASIN</label>
                        <input
                                type="text"
                                class="form-control small-option-font"
                                formControlName="asin"
                        />
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Payment Reference</label>
                        <input
                                type="text"
                                class="form-control small-option-font"
                                formControlName="rrr"
                        />
                    </div>

                    <div class="col-md-4 mt-2 me-2">
                        <button
                                class="btn btn-sm search-button small-option-font pointer"
                                (click)="search()"
                                type="submit"
                        >
                            Search
                        </button>
                    </div>
                    <div class="col-md-3 mt-2 ">
                        <button
                                class="btn btn-sm reset-button small-option-font"
                                (click)="resetForm()"
                                type="submit"
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div class="table-responsive">
        <table
                class="table table-striped table-hover table-bordered"
                *ngIf="selectedOutput == 'all'"
        >
            <thead class="table-dark">
            <tr>
                <th scope="col" class="assess-table-head">S/N</th>
                <th scope="col" class="assess-table-head">ASIN</th>
                <th scope="col" class="assess-table-head">REVENUE NAME</th>
                <th scope="col" class="assess-table-head">REVENUE CODE</th>
                <th scope="col" class="assess-table-head">PAYMENT DATE</th>
                <th scope="col" class="assess-table-head">PAYMENT REF.</th>
                <th scope="col" class="assess-table-head">AMOUNT</th>
                <th scope="col" class="assess-table-head">PAYMENT STATUS</th>
                <th scope="col" class="assess-table-head">ACTION</th>
            </tr>
            </thead>

            <tbody *ngIf="!isSearching && details?.length > 0">
            <tr *ngFor="let eachDetail of details; let i = index">
                <td>
                    <span class="badge bg-dark">{{ i + 1 + num }}</span>
                </td>
                <td>{{ eachDetail?.asin }}</td>
                <td>{{ eachDetail?.revenueName | uppercase | removeUnderscores }}</td>
                <td>{{ eachDetail?.revenueCode }}</td>
                <td>{{ eachDetail?.paymentDate | date }}</td>
                <td>{{ eachDetail?.rrr | uppercase }}</td>
                <td>
                    {{ eachDetail?.taxDue || eachDetail?.amount | nairaCurrency }}
                </td>
                <td>
            <span
                    class="badge {{
                eachDetail?.paymentStatus === 'APPROVED'
                  ? 'bg-success'
                  : 'bg-warning'
              }}"
            >
              {{ eachDetail?.paymentStatus | uppercase | removeUnderscores }}
            </span>
                </td>

                <td class="user-type-td">
                    <div ngbDropdown class="d-inline">
                        <button
                                class="btn btn-secondary btn-sm btn-flat"
                                id="dropdownBasic1"
                                ngbDropdownToggle
                                type="button"
                        >
                            Action
                        </button>
                        <div
                                ngbDropdownMenu
                                aria-labelledby="dropdownBasic1"
                                class="dropdown-menu-flat"
                        >
                            <a (click)="sendToKafka(eachDetail)" style="font-family: Inter;font-size: 14px;font-style: normal;"
                                    ngbDropdownItem
                                    class="dropdown-item-flat"
                            >
                                Send to Tax2.0
                            </a>
                            <a
                                    *ngIf="eachDetail?.paymentStatus == 'APPROVED'"
                                    style="
                    font-family: Inter;
                    font-size: 14px;
                    font-style: normal;
                  "
                                    ngbDropdownItem
                                    class="dropdown-item-flat"
                                    (click)="downloadPaymentReceipt(eachDetail?.rrr)"
                            >
                                Download Receipt
                            </a>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        </div>

        <div
                class="d-flex justify-content-center mt-3"
                *ngIf="selectedOutput == 'all'"
        >
            <p *ngIf="isSearching" class="text-muted">Please wait...</p>
            <p *ngIf="isEmpty" class="text-danger">No Payment found</p>
        </div>

        <div class="pagination justify-content-end" *ngIf="selectedOutput == 'all'">
            <ngb-pagination
                    *ngIf="!isSearching && details?.length > 0"
                    class="d-flex justify-content-center my-3"
                    [(page)]="currentPage"
                    (pageChange)="callDb($event)"
                    [maxSize]="5"
                    [pageSize]="pageSize"
                    [collectionSize]="count"
                    [boundaryLinks]="true"
                    [directionLinks]="true"
                    [rotate]="true"
            >
            </ngb-pagination>
        </div>

        <div class="search-summary mb-5" *ngIf="selectedOutput == 'countValue'">
            <div class="border-first pr-3">
                <h6 class="mt-3">Revenue Type</h6>
                <p class="small-option-font">
                    {{ countDetails?.revenueName | uppercase }}
                </p>
            </div>

            <div class="border-right pr-3">
                <h6 class="mt-3">Payment Status</h6>
                <p class="small-option-font">APPROVED</p>
            </div>

            <div class="border-right pr-3">
                <h6 class="mt-3">Count</h6>
                <p class="small-option-font">{{ countDetails?.count }}</p>
            </div>

            <div class="border-last pr-3">
                <h6 class="mt-3">Value</h6>
                <p class="small-option-font">
                    {{ countDetails?.totalAmount | nairaCurrency }}
                </p>
            </div>
        </div>
        <div
                class="d-flex justify-content-center mt-3"
                *ngIf="selectedOutput == 'countValue'"
        >
            <p *ngIf="isSearching" class="text-muted">Please wait...</p>
            <p *ngIf="isEmpty" class="text-danger">No Payment found</p>
        </div>

        <div
                class="d-flex justify-content-center mt-2 mb-5"
                *ngIf="searchInstruction"
        >
            <p class="text-muted">Please perform a search to view data.</p>
        </div>
    </div>
</div>

<!-- <div style="position: sticky !important;bottom: 0 !important;"> -->
<div>
    <app-footer *ngIf="hasAccess(['ADMIN'])" class="m-hidden"></app-footer>
    <app-mda-footer *ngIf="hasAccess(['MDA'])" class="m-hidden"></app-mda-footer>

</div>
